
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import './shared/design/tokens.css';
import './shared/design/global.css';

import { createQueryClient } from '@client/shared/lib/query-client.ts';
import { installGlobalErrorReporting } from '@client/shared/lib/report-client-error.ts';
import { SessionProvider } from '@client/shared/auth/index.ts';
import { ErrorBoundary } from './app/ErrorBoundary.tsx';
import { RouterProvider } from '@client/shared/router/router.tsx';
import { App } from './app/App.tsx';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found: index.html is missing its mount node.');
}

installGlobalErrorReporting();

const queryClient = createQueryClient();

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider>
            <App />
          </RouterProvider>
        </SessionProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
